import classNames from "classnames/bind";
import styles from "./Filter.module.css";
import { useEffect, useState } from "react";
import { departmentFSR } from "../../../../../../../services/api/departmentFSR";
import { companyFSR } from "../../../../../../../services/api/companyFSR";
import { SearchBlack } from "../../../../../../../components/Icons/Icons";
import { SelectBox, SelectBoxItem } from "../../../../../../../components";
import { checkRoleSupAdmin } from "../../../../../../../utils";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);

const Filter = ({ value, onChangeFilter, onReFresh }) => {
    const [showModalAdd, setShowModalAdd] = useState(false)
    const [listDepartment, setListDepartment] = useState([])
    const [listCompanies, setListCompanies] = useState([])
    const { t } = useTranslation();

    const handleChangeValue = (key, value) => {
        if (key === 'name' && value?.trim()?.length === 0) {
            onChangeFilter('name', null)
        } else {
            onChangeFilter(key, value)
        }
    }
    const handleShowAddObject = () => {
        setShowModalAdd(!showModalAdd)
    }

    const getListDepartment = async (company) => {
        try {
            const param = {
                page: 1,
                limit: 1000,
                organization_code: company
            }
            const res = await departmentFSR.get(param)
            if (res && res?.data) {
                const departments = res?.data?.map(item => {
                    return {
                        value: item?.id,
                        label: item?.name
                    }
                })
                setListDepartment(departments)
            }
        } catch (error) {
            // console.log(error);
        }
    }
    const getListCompany = async () => {
        try {
            const res = await companyFSR.get();
            if (res) {
                const companies = res?.map(item => {
                    return {
                        value: item?.CODE,
                        label: item?.NAME
                    }
                })
                setListCompanies(companies)
            }
        } catch (error) {
            // console.log(error);
        }
    }

    useEffect(() => {
        if (checkRoleSupAdmin()) {
            getListCompany()
        }
    }, [])
    useEffect(() => {
        if (value?.organizationCode) {
            getListDepartment(value?.organizationCode)
        }
    }, [value?.organizationCode])
    return (
        <div className={cx('wraper-fillter')}>
            <div className={cx("filter")}>
                <div className={cx("search")}>
                    <p className={cx('label')}>{t('faceDetect.nameEmploy')}</p>
                    <input
                        className={cx("search-input")}
                        value={value?.name}
                        //   onChange={onChangeTextSearch}
                        placeholder={t('location.find')}
                        onChange={(e) => handleChangeValue('name', e.target.value)}
                    />
                    <span className={cx("icon-search")}>
                        <SearchBlack />
                    </span>
                </div>
                {checkRoleSupAdmin() && (
                    <SelectBox
                        type="small"
                        title={t('faceDetect.company')}
                        className={cx('select')}
                        onChange={(e) => {
                            handleChangeValue('organizationCode', e);
                            handleChangeValue('organizationName', listCompanies?.find(cop => cop?.value === e)?.label)
                        }}
                        values={value?.organizationName}
                    >
                        <SelectBoxItem label={"Tất cả"} value={"all"} />
                        {
                            listCompanies?.length > 0 ? listCompanies?.map(item => {
                                return <SelectBoxItem key={item?.value} label={item?.label} value={item?.value} />
                            }) : <></>
                        }
                    </SelectBox>
                )}
                <SelectBox
                    type="small"
                    title={t('faceDetect.depart')}
                    className={cx('select')}
                    onChange={(e) => handleChangeValue('department', e)}
                >
                    <SelectBoxItem label={t('smartReport.all')} value={null} />
                    {
                        listDepartment?.length > 0 ? listDepartment?.map(item => {
                            return <SelectBoxItem key={item?.value} label={item?.label} value={item?.value} />
                        }) : <></>
                    }
                </SelectBox>
            </div>
        </div>

    )
}

export default Filter;